import {isMobile} from '@/src/shared/utils/functions'
import {csrfHeaderName, mobileTokenHeaderName, settings} from '@/src/config/settings'
import {MobileStorage} from '@/src/infrastructure/data/storage'

export const getClientCredentials = async () => {
    const headers: Record<any, any> = {}

    if (isMobile()) {
        const storage = new MobileStorage()
        const mobileCsrf = await storage.getItem<string>('mobileCsrf')
        if (mobileCsrf) {
            headers![csrfHeaderName] = mobileCsrf
        }
        headers![mobileTokenHeaderName] = settings.NEXT_PUBLIC_MOBILE_TOKEN
        headers!['X-Mobile'] = 'true'
    }

    return headers
}
